var map = {
	"./boost.jpg": 2024,
	"./energy.jpg": 7410,
	"./garden.jpg": 9213,
	"./lify-banner-en.jpg": 7773,
	"./lify-banner-tc.jpg": 5029,
	"./revive.jpg": 4221,
	"./sleep.jpg": 3106,
	"./sooth.jpg": 8541,
	"./sunrise.jpg": 1153,
	"./sunset.jpg": 673,
	"./teatox.jpg": 7414,
	"./young.jpg": 5067
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7020;